import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  restoreSupportingDocument,
  uploadSupportingDocument,
} from './index';

export const createNominationSupportingDocumentsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  uploadSupportingDocument: (instance: IPublicClientApplication, nominationId: number, documentContent: File) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => uploadSupportingDocument(fetchContext, nominationId, documentContent, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('uploadSupportingDocument', isInFlight);
    },
  ),
  restoreSupportingDocument: (instance: IPublicClientApplication, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => restoreSupportingDocument(fetchContext, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('restoreSupportingDocument', isInFlight);
    },
  ),
});
